module.exports = __webpack_public_path__ + "img/sh.6eda5466.png";